// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1U96p","footer":"ModalCreateQualiphyProcedure_footer__2tvfQ","additionData":"ModalCreateQualiphyProcedure_additionData__3QhXe"};